const SocialMediaName = Object.freeze({
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  SNAPCHAT: 'snapchat',
  YOUTUBE: 'youtube',
  REDDIT: 'reddit',
  PINTEREST: 'pinterest',
  TIKTOK: 'tiktok',
  TWITCH: 'twitch',
  SPOTIFY: 'spotify',
  PATREON: 'patreon',
} as const);

export type SocialMediaName = (typeof SocialMediaName)[keyof typeof SocialMediaName];

export const allSocialMediaNames: [SocialMediaName, ...SocialMediaName[]] = Object.values(SocialMediaName) as [
  SocialMediaName,
  ...SocialMediaName[],
];

export default SocialMediaName;
